import { render } from "./PastAndCanceledRequests.vue?vue&type=template&id=24bae487&scoped=true"
import script from "./PastAndCanceledRequests.vue?vue&type=script&lang=js"
export * from "./PastAndCanceledRequests.vue?vue&type=script&lang=js"

import "./PastAndCanceledRequests.vue?vue&type=style&index=0&id=24bae487&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24bae487"

export default script